export const dispatchEvent = (event: CustomEvent) => window.dispatchEvent(event)
